
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

////////////////////////// Top Off Last Entry Name //////////////////////////
export const topOffLastEntryName = createAsyncThunk('users/topOffLastEntryName', async (reqBody) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqBody)
  }
  console.log("reqBody====>", reqBody)
  const response = await fetch(`${process.env.REACT_APP_API_URL}api/topOfflastEntry`, requestOptions);
  const res = response.json();
  return res;
})


const tpmReducer = createSlice({

  name: "tpmEntry",
  initialState: {
    userName: null,
  },

  reducers: {


  },

  extraReducers: {
    /////////////////////// fetching user top off Name ///////////////////
    [topOffLastEntryName.pending]: (state, action) => {

    },
    [topOffLastEntryName.fulfilled]: (state, action) => {
      if (action.payload.status === 'success') {
        if (action.payload.results.res[0]) state.userName = action.payload.results.res[0]
        else state.userName = false
      } else {
        state.userName = null
      }


    },
    [topOffLastEntryName.rejected]: (state, action) => {

    },
  }


});



export default tpmReducer.reducer;
